import './App.css';
import MultiStepForm from './MultiStepForm';

function App() {
  return (
    <div className="App">
      <div className='padding-global'>       
        <MultiStepForm />
      </div>
      
    </div>
  );
}

export default App;
